export default __webpack_public_path__ + "static/media/wrong_beverages@2x.87c7a0ac.jpg";